export default __webpack_public_path__ + "static/media/Data-entryCr.2344ca90.png";